import cssUtil from 'gw-portals-util-js/CssUtil';
import styles from './PaQuickQuoteEstimate-hashed.scss';
import templateStr from 'text!./PaQuickQuoteEstimate.html';
import ProductMediaMapUtil from 'gw-portals-util-js/ProductMediaMapUtil';

export default ['ViewModelService', function (ViewModelService) {
    return {
        restrict: 'E',
        scope: {
            email: '=',
            estimate: '=',
            isActive: '&',
            isPanelValid: '&',
            transitionFn: '&',
            model: '=',
            submission: '=',
            flow: '='
        },
        template: cssUtil.hashTemplate(templateStr, styles),

        controller: ['$scope', '$q', 'ModalService', 'qnb.EmailService', '$translate', function ($scope, $q, ModalService, QuoteEmailService, $translate) {
            var emailQuoteDTO = {
                'quoteID': '',
                'sessionID': '',
                'emailAddress1': ''
            };
            $scope.quoteEmailVM = ViewModelService.create(emailQuoteDTO, 'pc', 'edge.capabilities.quote.mailing.dto.QuoteEmailDTO');
            $scope.productOrFeatureImage = ProductMediaMapUtil.getProductCodeImage('QuickQuote');

            $scope.isEmailValid = function () {
                return $scope.quoteEmailVM.emailAddress1.value !== '' && $scope.quoteEmailVM.emailAddress1.aspects.valid && $scope.quoteEmailVM.emailAddress1.aspects.subtreeValid;
            };

            $scope.emailQuote = function () {
                var emailAddress = $scope.quoteEmailVM.emailAddress1.value;
                $scope.submission.baseData.accountHolder.emailAddress1.value = emailAddress;
                var emailInfo = {
                    quoteID: $scope.submission.quoteID.value,
                    sessionID: $scope.submission.sessionUUID.value,
                    emailAddress1: emailAddress
                };
                $q.when(QuoteEmailService.emailQuote(emailInfo), function () {
                    ModalService.showInfo('quoteandbind.quickquote.pa.directives.Estimate.Quote Emailed', $translate('quoteandbind.quickquote.pa.directives.Estimate.The quote details have been emailed to', {
                        emailAddress: emailAddress
                    }));
                }, function () {
                    ModalService.showError('quoteandbind.directives.QnbWizardButtons.Error', 'quoteandbind.directives.QnbWizardButtons.Sorry, we were not able to email the quote details at this time.');
                });
            };

            $scope.startOver = function () {
                $scope.flow.next({ resetToStart: true });
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/quickquote/pa/directives/Estimate/PaQuickQuoteEstimate.js
// module id = 2188
// module chunks = 0